import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import { type MemberDownloads } from "./types";

export const localStateSelector = makeModuleStateSelector<MemberDownloads.AppState>(defaultState, previewState);
